/**
 * Created by Carsten Bühler
 * User: CBuehler on 23.09.2015
 * Copyright: xdot GmbH 2015
 */

import { RemoteDataActions } from 'plugin/liferay-widgets-react-web';


const api = 'GeoJsonWebApi';
const itemApiMethod = 'getGeoJson';

const pollingData = {};

setInterval(() => {
    const t = new Date().getTime();
    Object.keys(pollingData).filter(name => (t - pollingData[ name ] > 1000)).forEach(name => {
        pollingData[ name ] = t;
        RemoteDataActions.invalidate(name, "GeoJson");
    });
}, 1000 * 60);

export default {

    geoJson: (name, query) => {
        pollingData[ name ] = new Date().getTime();
        return RemoteDataActions.item(name, "GeoJson", query, api + '.' + itemApiMethod);
    },

};



// WEBPACK FOOTER //
// ./js/actions/GeoJsonActions.js